// @flow

import getHiddenFacetsByConfiguration
  from './get-facets-hidden-by-configuration';

const facetsHiddenByConfiguration = (
    departmentHidden: boolean,
    priceHidden: boolean,
    ratingsHidden: boolean,
): Function => (facet: FacetWithConfig): boolean => (
    !getHiddenFacetsByConfiguration(
        facet,
        departmentHidden,
        priceHidden,
        ratingsHidden,
    ).includes(facet.name)
);

export default facetsHiddenByConfiguration;
